import React from 'react'
import styled from 'styled-components'

import { HighlightedText, pluralize, DeletingIn } from '@sketch/components'

import {
  ImageWrapper,
  GridWrapper,
  Name,
  DropdownButtonWrapper,
} from '../DocumentItem/DocumentItem.styles'
import {
  StyledSubtitleTextWrapper,
  StyledFolderIcon,
} from './ProjectItem.styles'
import {
  ProjectItemProps,
  getButtonProps,
  renderDropdown,
  renderPreview,
} from './utils'
import { useSearch } from '@sketch/utils'
import { useFolderTerm } from '@sketch/modules-common'

export const ProjectItemGridView = styled(function ProjectItemGridView(
  props: ProjectItemProps
) {
  const {
    archivedAt,
    className,
    name,
    childrenItemCount = 0,
    childrenItemLabel = pluralize('Document', 'Documents', childrenItemCount),
    deletedAt,
    renderDropdownItems,
    onClick,
  } = props

  const folderTerm = useFolderTerm()

  const previewImage = renderPreview(props, 'grid', folderTerm)
  const a11yProps = onClick ? getButtonProps(onClick) : {}
  const { search } = useSearch()

  return (
    <GridWrapper
      className={className}
      title={name}
      data-testid="project-item"
      {...a11yProps}
    >
      <ImageWrapper>{previewImage}</ImageWrapper>
      <Name>
        <StyledFolderIcon aria-label="Folder Icon" />
        <HighlightedText search={search}>{name}</HighlightedText>
      </Name>
      <StyledSubtitleTextWrapper>
        <b className="shrink">{`${childrenItemCount} ${childrenItemLabel}`}</b>

        {archivedAt && <div className="keep-size">Archived</div>}

        {deletedAt && (
          <div className="keep-size">
            <DeletingIn deletedAt={deletedAt} />
          </div>
        )}
      </StyledSubtitleTextWrapper>

      {renderDropdownItems && (
        <DropdownButtonWrapper>
          {renderDropdown(renderDropdownItems(), props.deletedAt)}
        </DropdownButtonWrapper>
      )}
    </GridWrapper>
  )
})``
